import { Box, FormControl } from '@primer/react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/ui/button';
import Modal from '../../../components/ui/modal';
import ModalActions from '../../../components/ui/modal/ModalActions';
import Text from '../../../components/ui/text';
import TextInput from '../../../components/ui/text-input';
import { useCommonContext } from '../../../contexts/common';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { IDmNguonBietToiType } from '../../../models/response/category/IDmNguonBietToiType';
import { actions } from '../../../state/actions/actionsWrapper';
import { RootState } from '../../../state/reducers';

const NguonBietToiTypeEditModal = () => {
    const { status, editingData } = useSelector((x: RootState) => x.crmCategoryWrapper.nguonBietToiType)
    const dispatch = useDispatch();
    const { translate } = useCommonContext();
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm<IDmNguonBietToiType>({
        defaultValues: editingData ? {
            ...editingData,
        } : undefined
    })
    const onSubmit = async (data: any) => {

        dispatch(actions.crmCategoryWrapper.nguonBietToiType.SAVE_START({
            ...data,
            id: data?.id ?? 0
        }))
    }

    return (
        <Modal isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={() => {
                dispatch(actions.crmCategoryWrapper.nguonBietToiType.CLOSE_EDIT_MODAL(undefined))
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <FormControl>
                        <FormControl.Label><Text text='NguonBietToiType.Name' /></FormControl.Label>
                        <TextInput block
                            name="name"
                            register={register}
                            errors={errors}
                            required
                            validateMessage={`${translate("Base.Form.RequiredMessage")} ${translate("NguonBietToiType.Name")}`}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='NguonBietToiType.NameEn' /></FormControl.Label>
                        <TextInput block
                            name="name_en"
                            register={register}
                            errors={errors}
                            required
                            validateMessage={`${translate("Base.Form.RequiredMessage")} ${translate("NguonBietToiType.NameEn")}`}
                        />
                    </FormControl>
                </Box>

                <ModalActions>
                    <Button text='Base.Label.Close' onClick={() => {
                        dispatch(actions.crmCategoryWrapper.nguonBietToiType.CLOSE_EDIT_MODAL(undefined))
                    }} />
                    <Button text='Base.Label.Update' variant='primary' type='submit'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>

        </Modal>
    );
};

export default NguonBietToiTypeEditModal;